export default __webpack_public_path__ + "static/media/open-sans-latin-700italic.2a0783bd.woff2";